import {Component, OnInit} from '@angular/core';
import {
  GetCurrentUser,
  GetLanguage,
} from 'src/app/shared/functions/shared-functions';
import {CoreService} from '../../../services/core.service';
import {secureStorage} from 'src/app/shared/functions/secure-storage';
import {LocationStrategy} from '@angular/common';
import moment from 'moment';
import {dateTimeCompleteFormat} from '../../variables/variables';
import {ActivatedRoute, Router} from '@angular/router';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-new-systems-print',
  templateUrl: './new-systems-print.component.html',
  styleUrls: ['./new-systems-print.component.scss']
})
export class NewSystemsPrintComponent implements OnInit {
  invoicesData: any[] = [];
  // displayedColumns contains list of the columns that used in Invoice Table.
  displayedColumns: string[] = ['serviceName', 'description'];
  printData: any = [];
  receiptData;
  cashier_name;
  currentUser: any;
  paymentMethods: any[] = [];
  filteredPayment: any[] = [];
  cashierFullName: string;
  language = GetLanguage();
  printAr: boolean;
  data_id;
  loading = false;
  casheir_type;
  listRoute;
  logo;
  action_code;
  actionCodesShowNumOfYearsAndExpiry = [
    'Annualmembership',
    'RenewAnnualmembership',
    'Newstudentmembership',
    'Studentmembershiprenewal',
  ];
  actionCodesShowMembershipNum = [
    'Annualmembership',
    'RenewAnnualmembership',
    'Newstudentmembership',
    'Studentmembershiprenewal',
    'ConvertFromAnnualtopermanent',
    'permanentmembership',
  ];
  actionCodesShowOrganization = ['RenewAnnualmembership'];
  NeededSystemActionCode;
  PageCode;

  constructor(
    private coreService: CoreService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private location: LocationStrategy,
  ) {
    // DISABLE BACK BUTTON (NOT TO SUBMIT SERVICE COLLECTION AGAIN)
    history.pushState(null, null, window.location.href);
    this.location.onPopState(() => {
      history.pushState(null, null, window.location.href);
    });
  }

  ngOnInit(): void {
    this.data_id = secureStorage.decryptItem(
      this.activatedRoute.snapshot.queryParams?.id?.replaceAll(' ', '+'),
    );
    this.casheir_type = this.activatedRoute.snapshot.queryParams?.casheir_type;
    this.NeededSystemActionCode = this.activatedRoute.snapshot.queryParams?.NeededSystemActionCode;
    this.PageCode = this.activatedRoute.snapshot.queryParams?.PageCode;
    this.listRoute = this.activatedRoute.snapshot.queryParams?.route;
    window.onafterprint = () => {
      // Your action after print is completed;
      this.navigateTopPrint();
    };
    this.logo =
      this.language === 'ar'
        ? 'assets/img/logos/arabic-logo-transparent.png'
        : 'assets/img/logos/english-logo-transparent.png';
    this.getData();
  }

  getData() {
    this.loading = true;
    this.coreService
      .getRequest(
        `Oneincome/api/Casher/GetAllCasher?NeededSystemActionCode=${this.NeededSystemActionCode}&PageCode=${this.PageCode}&id=${this.data_id}`, {}, true, false
      )
      .pipe(untilDestroyed(this))
      .subscribe((res) => {
        const data: any = res[0];
        this.receiptData = {...data?.persondata, ...data?.serviceRequest[0], ...data}
        this.action_code = this.receiptData?.service?.actionCode;
        this.printData = data?.persondata;
        this.receiptData['serviceName'] =
          this.language === 'ar'
            ? this.receiptData?.service.nameAr
            : this.receiptData?.service.nameEn;
        if (this.receiptData?.receiptDate) {
          this.receiptData['receiptDate'] = moment(
            this.receiptData?.receiptDate,
          )
            ?.locale('en')
            .format(dateTimeCompleteFormat);
        }
        if (
          this.receiptData?.discount &&
          this.receiptData?.discount !== '0'
        ) {
          this.displayedColumns.push('discount');
          this.displayedColumns.push('total');
        } else {
          this.displayedColumns.push('total');
        }
        if (
          this.NeededSystemActionCode === 'Traninng'
        ) {
          this.displayedColumns.push('course_name');
          this.receiptData.course_name =
            GetLanguage() === 'ar'
              ? this.receiptData?.course?.nameAr || '--'
              : this.receiptData?.course?.nameEn || '--';
        }
        this.checkServiceType();
        this.handleData();
        this.printAr = this.language === 'ar';
        this.invoicesData = [
          {
            service:
              this.language === 'ar'
                ? this.receiptData?.service.nameAr
                : this.receiptData?.service.nameEn,
          },
        ];
        this.getPayment();
      });
  }

  handleData() {
    [this.receiptData].map(
      (item) =>
        (item.paymentMethod.name =
          this.language === 'ar'
            ? item.paymentMethod.nameAr
            : item.paymentMethod.nameEn),
    );
    console.log('daa', this.receiptData)
    if (!this.printData.arabicName) {
      this.printData.arabicName =
        this.printData?.firstNameAr +
        ' ' +
        (this.printData?.secondNameAr && this.printData?.secondNameAr !== '-'
          ? this.printData?.secondNameAr
          : '') +
        ' ' +
        (this.printData?.thirdNameAr && this.printData?.thirdNameAr !== '-'
          ? this.printData?.thirdNameAr
          : '') +
        ' ' +
        this.printData?.familyNameAr && this.printData?.familyNameAr !== '-' ? this.printData?.familyNameAr : ''
      this.printData.englishName =
        this.printData?.firstNameEN +
        ' ' +
        (this.printData?.secondNameEN && this.printData?.secondNameEN !== '-'
          ? this.printData?.secondNameEN
          : '') +
        ' ' +
        (this.printData?.thirdNameEN && this.printData?.thirdNameEN !== '-'
          ? this.printData?.thirdNameEN
          : '') +
        ' ' +
        this.printData?.familyNameEN && this.printData?.familyNameEN !== '-' ? this.printData?.familyNameEN : '';
    }
    this.cashier_name =
      this.receiptData?.user?.firstName +
      ' ' +
      (this.receiptData?.user?.socondName && this.receiptData?.user?.socondName !== '-'
        ? this.receiptData?.user?.socondName
        : '') +
      ' ' +
      (this.receiptData?.user?.thirdName && this.receiptData?.user?.thirdName !== '-'
        ? this.receiptData?.user?.thirdName
        : '') +
      ' ' +
      this.receiptData?.user?.familyName && this.receiptData?.user?.familyName !== '-' ? this.receiptData?.user?.familyName : '';

    this.printData.fullName =
      this.language === 'ar'
        ? this.printData.arabicName
        : this.printData.englishName;
    this.loading = false;
  }

  checkServiceType() {
    // show num of years and expiry date
    if (
      this.receiptData?.personMembership &&
      this.actionCodesShowNumOfYearsAndExpiry.includes(this.action_code)
    ) {
      this.displayedColumns.push('numOfYears');
      if (this.receiptData.personMembership?.expiryDate) {
        this.displayedColumns.push('expiryDate');
        this.receiptData.personMembership.expiryDate = moment(
          this.receiptData.personMembership?.expiryDate,
        )
          ?.locale('en')
          .format('yyyy-MM-DD');
      }
    }
    // show SupportDirectedTo
    if (this.action_code === 'SupportDirectedTo') {
      this.displayedColumns.push('supportDirectedTo');
      this.receiptData.support_directed_to = GetLanguage() === 'ar'
        ? this.receiptData?.supportDirectTo?.nameAr || ''
        : this.receiptData?.supportDirectTo?.nameEn || '';
    }
    // show OtherServices
    if (this.action_code === 'OtherServices') {
      this.displayedColumns.push('OtherServices');
      this.receiptData.other_service = GetLanguage() === 'ar'
        ? this.receiptData?.otherService?.nameAr || ''
        : this.receiptData?.otherService?.nameEn || '';
    }
    // show membershipNumber
    if (this.actionCodesShowMembershipNum.includes(this.action_code)) {
      if (this.receiptData?.personMembership?.membershipNum) {
        this.displayedColumns.push('membershipNumber');
      }
    }
    // show organization
    if (this.actionCodesShowOrganization.includes(this.action_code)) {
      this.receiptData.organization =
        GetLanguage() === 'ar'
          ? this.receiptData?.serviceRequest?.organization?.nameAr
          : this.receiptData?.serviceRequest?.organization?.nameEn;
    }
  }

  getPayment() {
    this.coreService.getRequest('PaymentMethod').subscribe((res) => {
      res = res.filter((el) => {
        return (
          el.isActive === true && el.isDeleted === false && el.isOline === false
        );
      });
      res?.map(
        (item) =>
          (item.name = this.language === 'ar' ? item.nameAr : item.nameEn),
      );
      if (!this.printData.putAction) {
        this.printData.paymentMethod = res.find(
          (x) => x.id === this.printData?.serviceRequest?.paymentMethodId,
        );
      }
    });
  }

  navigateTopPrint() {
    if (
      this.action_code === 'RenewAnnualmembership' ||
      this.action_code === 'ConvertFromAnnualtopermanent' ||
      this.action_code === 'permanentmembership' ||
      this.action_code === 'ReplacementMembershipCard' ||
      this.action_code === 'Annualmembership'
    ) {
      this.router.navigate(['/membership/membership-cards-list'], {
        queryParams: {passportNum: this.printData?.passportNum},
      });
    } else if (
      this.action_code === 'NOC' ||
      this.action_code === 'ToWhomConcernCertificateOutsideFee' ||
      this.action_code === 'ToWhomConcernCertificateFee'
    ) {
      this.router.navigate(['/issued-certificate-list'], {
        queryParams: {passportNum: this.printData?.passportNum},
      });
    } else if (
      this.action_code === 'IssuingSupervisoryEngCertSameOfficeFee' ||
      this.action_code === 'ToWhomConcernCertFeeProfessionalEng' ||
      this.action_code === 'ReplacementForLostProfessionalEngCertFee' ||
      this.action_code === 'ReplacementForLostConsultantEngCertFee' ||
      this.action_code === 'ReplacementForLostConsultantEngIdentity' ||
      this.action_code === 'ConsultantEngIdentityRenewalfee' ||
      this.action_code === 'ToWhomConcernCertFeeSupervisorEng'
    ) {
      this.router.navigate(
        ['/classification/classification-certificates-list'],
        {queryParams: {passportNum: this.printData?.passportNum}},
      );
    } else if (
      this.action_code === 'ConsultantEngIdentityRenewalfee' ||
      this.action_code === 'ReplacementForLostProfessionalEngIdentity' ||
      this.action_code === 'ProfessionalEngIdentityRenewalfee' ||
      this.action_code === 'ReplacementForLostSupervisorEngIdentity' ||
      this.action_code === 'SupervisorlEngIdentityRenewalfee' ||
      this.action_code === 'ReplacementForLostConsultantEngIdentity'
    ) {
      this.router.navigate(['/classification/classification-cards-list'], {
        queryParams: {passportNum: this.printData?.passportNum},
      });
    }
  }

  firePrint() {
    window.print();
  }

  back() {
    if (this.listRoute) {
      this.router.navigate([`/${this.listRoute}`]);
    } else {
      if (this.casheir_type === 'grouped') {
        this.router.navigate(['/grouped-cashier-list']);
      } else {
        this.router.navigate([`/${this.casheir_type}/cashier-list`]);
      }
    }
  }
}
